/* ==========================================================================
   TRE TEMPI SORRISO · JavaScript condiviso (tretempi.js)
   Va caricato una sola volta nel tema (con "defer"). Vale per tutte le pagine.
   Fa quattro cose:
   1. collega i blocchi con l'evento "tt:select-level" (livello 1, 2 o 3)
   2. fa funzionare il test del sorriso (le domande stanno nel blocco, non qui)
   3. scorre fino ai livelli quando si clicca un pulsante con data-tt-go
   4. mostra la barra di acquisto fissa su mobile
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function scrollToEl(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- 1. Selezione del livello ---------- */
  function selectLevel(n) {
    var cards = qsa('.tt-lv');
    if (!cards.length) return;
    var idx = Math.min(Math.max(parseInt(n, 10) || 1, 1), cards.length) - 1;
    var card = cards[idx];
    if (!card || card.classList.contains('is-off')) return;
    cards.forEach(function (c) { c.classList.toggle('is-sel', c === card); });
    scrollToEl(qs('#tt-livelli') || card);
    var btn = qs('.tt-lv__cta', card);
    if (btn) { setTimeout(function () { btn.focus({ preventScroll: true }); }, reduce ? 0 : 600); }
  }
  window.addEventListener('tt:select-level', function (e) { selectLevel(e.detail); });

  /* ---------- 3. Pulsanti che scorrono a una sezione ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-tt-go]') : null;
    if (!t) return;
    e.preventDefault();
    scrollToEl(document.getElementById(t.getAttribute('data-tt-go')));
  });

  /* ---------- 2. Test del sorriso ---------- */
  // Calcola il livello consigliato. cfg.questions[i].a = [[testo, {livello: punti}], ...]
  function score(cfg, picks) {
    var s = { 1: 0, 2: 0, 3: 0 };
    picks.forEach(function (pair) {
      Object.keys(pair[1]).forEach(function (k) { s[k] += pair[1][k]; });
    });
    return [1, 2, 3].reduce(function (a, b) { return s[b] > s[a] ? b : a; });
  }

  function initQuiz(root) {
    var dataEl = qs('.tt-quiz__data', root);
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!cfg || !cfg.questions || !cfg.questions.length) return;

    var progress = qs('.tt-quiz__progress', root);
    var stepEl = qs('.tt-quiz__step', root);
    var qEl = qs('.tt-quiz__q', root);
    var ansEl = qs('.tt-quiz__answers', root);
    var resEl = qs('.tt-quiz__result', root);
    var step = 0, picks = [], best = 1;

    progress.innerHTML = '';
    cfg.questions.forEach(function () { progress.appendChild(document.createElement('i')); });
    var bars = qsa('i', progress);

    function start() {
      step = 0; picks = [];
      resEl.hidden = true; stepEl.hidden = false;
      render();
    }
    function render() {
      bars.forEach(function (b, i) { b.classList.toggle('on', i <= step); });
      qEl.textContent = cfg.questions[step].q;
      ansEl.innerHTML = '';
      cfg.questions[step].a.forEach(function (pair) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'tt-quiz__ans'; b.textContent = pair[0];
        b.addEventListener('click', function () {
          picks.push(pair);
          step++;
          if (step < cfg.questions.length) { render(); } else { finish(); }
        });
        ansEl.appendChild(b);
      });
    }
    function finish() {
      best = score(cfg, picks);
      stepEl.hidden = true;
      qs('.tt-quiz__rec', root).textContent = (cfg.names && cfg.names[best]) || ('Livello ' + best);
      qs('.tt-quiz__why', root).textContent = (cfg.why && cfg.why[best]) || '';
      resEl.hidden = false;
    }
    qs('.tt-quiz__cta', root).addEventListener('click', function () {
      window.dispatchEvent(new CustomEvent('tt:select-level', { detail: best }));
    });
    qs('.tt-quiz__again', root).addEventListener('click', start);
    start();
  }

  /* ---------- 4. Barra di acquisto fissa (mobile) ---------- */
  function initSticky(bar) {
    if (!('IntersectionObserver' in window)) { return; }
    var hero = qs('[data-tt-hero-cta]');
    var levels = qs('#tt-livelli');
    if (!hero) { return; }
    var heroOut = false, levelsIn = false;
    function update() { bar.classList.toggle('is-on', heroOut && !levelsIn); }
    new IntersectionObserver(function (en) {
      heroOut = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      update();
    }).observe(hero);
    if (levels) {
      new IntersectionObserver(function (en) { levelsIn = en[0].isIntersecting; update(); }, { threshold: 0.1 }).observe(levels);
    }
  }

  function init() {
    qsa('[data-tt-quiz]').forEach(initQuiz);
    qsa('[data-tt-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  // utile per i test
  window.TT = { selectLevel: selectLevel, score: score };
})();